export const PERSIST_ENTERED_INFO = 'PERSIST_ENTERED_INFO'
